<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/notification')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">

              <b-row class="mb-20">
                  <b-col sm="2">
                    <label>Branch</label>
                  </b-col>
                  <b-col sm="6">
                    <b-form-select name="branch" v-model="addData.branch_id" @change="changeBranch">
                        <option v-for="item in dataBranch" :key="item.value" :value="item.value">{{item.text}}</option>
                      </b-form-select>
                  </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Add Member</label>
                </b-col>
                <b-col sm="6">
                  <div class="custom-search-select">
                    <multi-select :options="optionAddNewMember"
                      :selected-options="items"
                      placeholder="Select Member"
                      :selectedItems = "items"
                      name="new_member_id"
                      :isDisabled="is_all_user"
                      @select="onSelect">
                    </multi-select>
                  </div>
                  <span class="error">{{ errors.first('member') }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="2">
                  <div class="label-name">Membership Status</div>
                </b-col>
                <b-col sm="6">
                  <b-form-select name="membership_status_id" v-model="addData.membership_status_id"
                    class="form-control">
                    <option value="null" selected>Please select</option>
                    <option v-for="(item, index) in dataMembershipStatus" :value="item.id" :key="index">{{ item.name }}
                    </option>
                  </b-form-select>
                </b-col>
              </b-row>

              <!-- <b-row class="mb-20">
                <b-col sm="2">
                  <label for="address">All</label>
                </b-col>
                <b-col sm="10">
                  <toggle-button v-model="is_all_user" name="is_all_user"/>
                  <span class="error">{{ errors.first('is_all_user') }}</span>
                </b-col>
              </b-row> -->
              
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Subject</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.subject" name="subject" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('subject') }}</span>
                </b-col>
              </b-row>
              
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="message">Message</label>
                </b-col>
                <b-col sm="10">
                  <!-- <textarea name="message" class="w-100" rows="3" v-validate="'required'" v-model="addData.message"></textarea> -->
                  <div>
                    <quill-editor class="editor-custom" name="message" ref="myTextEditor" v-model="addData.message" :config="editorOption"></quill-editor>
                  </div>
                  <span class="error">{{ errors.first('message') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<style lang="scss">
  .ql-editor {
    // background-color: #484848;
    // color: white;
  }
</style>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import { MultiSelect } from 'vue-search-select'
import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'addnotification',
  components: {
    MultiSelect,
    quillEditor
  },
  data: function () {
    return {
      loadingActive: false,
      editorOption: {
        // modules: {
        //   toolbar: [
        //     ['bold', 'italic', 'underline', 'strike'],
        //     ['blockquote', 'code-block'],
        //     [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }], 
        //   ]
        // }
      },
      dataBranch: [],
      optionAddNewMember: [],
      dataMembershipStatus: [],
      itemSales: [],
      items: [],
      lastSelectItem: {},
      countAvailForNewMember: 50,
      itemCS: [],
      is_all_user: false,
      addData: {
        branch_id: null,
        new_member_id: [],
        subject: null,
        message: null,
        is_all: 0,
        membership_status_id: null
      },
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ]
    }
  },
  methods: {
    onSelect (items, lastSelectItem) {

      if (this.items.length >= this.countAvailForNewMember) {
        // this.items = []
        // this.addData.new_member_id = []
        this.$toast.success("Max "+ this.countAvailForNewMember +" for new member ", "Error", {
          position: "topCenter",
          icon: "icon-envelope",
          progressBarColor: "rgb(0, 255, 184)",
          theme: "dark",
          backgroundColor: "#565c70",
          messageColor: "#fff"
        });
      } else {
        this.items = items
        this.lastSelectItem = lastSelectItem
        var new_member_id = this.addData.new_member_id.find((e) => e == lastSelectItem.value)
        if (!new_member_id) {
          this.addData.new_member_id.push(lastSelectItem.value)
        } else {
          var arr = this.addData.new_member_id.filter((e) => e != lastSelectItem.value)
          this.addData.new_member_id = arr
        }
      }
        // console.log(this.addData.new_member_id);
    },
    // deselect option
    reset () {
      this.items = [] // reset
    },
    // select option from parent component
    selectFromParentComponent () {
      this.items = _.unionWith(this.items, [this.options[0]], _.isEqual)
    },
    changeBranch(event) {
      this.loadingActive = true
      if (event == 'single') {
        this.is_all_user = false
      } else if (event == 'null') {
        this.is_all_user = true
      } else {
        this.is_all_user = false
      }
      axios.get('fitness/v1/member/list/for/notifications/fcm?branch_id='+ this.addData.branch_id).then(response => {
        const setMember = response.data.data.rows
        this.optionAddNewMember = []
        for (let i = 0; i < setMember.length; i++) {
          this.optionAddNewMember.push({ value: setMember[i].id, text: setMember[i].first_name + " " + setMember[i].last_name})
        }
        this.loadingActive = false
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    validateRegister () {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Send it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$validator.validateAll().then((result) => {
            if(result) {
              this.loadingActive = true
              if (this.addData.branch_id == 'null') {
                this.addData.is_all = 1
                this.addData.new_member_id = []
                this.reset()
              }
              if (this.addData.new_member_id.length == 0 && this.addData.branch_id == 'single') {
                this.loadingActive = false
                this.$toast.success('Member cannot be empty!', 'Error', {
                  position: 'topCenter',
                  icon: 'icon-envelope',
                  progressBarColor: 'rgb(0, 255, 184)',
                  theme: 'dark',
                  backgroundColor: '#565c70',
                  messageColor: '#fff'
                })
                return;
              }
              let styles = '<style>p {color: white;} a {color: white}</style>'
              this.addData.message.concat(styles)
              axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token

              // console.log(this.addData)
              axios.post('crm/v1/notification/', this.addData).then(response => {
                this.loadingActive = false
                // console.log('test', response)
                this.$router.push('/notification')
                this.$toast.success('data saved successfully!', 'Success', {
                  position: 'topCenter',
                  icon: 'icon-envelope',
                  progressBarColor: 'rgb(0, 255, 184)',
                  theme: 'dark',
                  backgroundColor: '#565c70',
                  messageColor: '#fff'
                })
              }).catch(error => {
                this.loadingActive = false
                // console.log('error log', error)
                this.$toast.success('cant saved data!', 'Error', {
                  position: 'topCenter',
                  icon: 'icon-envelope',
                  progressBarColor: 'rgb(0, 255, 184)',
                  theme: 'dark',
                  backgroundColor: '#565c70',
                  messageColor: '#fff'
                })
              })
            } else {
              this.loadingActive = false
              this.$toast.success('please fill in required fields!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            }
          })
        } else {
          this.$swal('Cancelled', '', 'info')
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    fetchData() {
      axios.get('fitness/v1/member/list/for/notifications/fcm?branch_id='+ this.addData.branch_id).then(response => {
        const setMember = response.data.data.rows
        for (let i = 0; i < setMember.length; i++) {
          this.optionAddNewMember.push({ value: setMember[i].id, text: setMember[i].first_name + " " + setMember[i].last_name})
        }
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        // this.dataBranch = response.data.data.rows
        this.dataBranch = [{value: 'null',text: 'All Member'}, {value: 'single',text: 'By Member'}]
        for (let i = 0; i < response.data.data.rows.length; i++) {
          this.dataBranch.push({value: response.data.data.rows[i].id,text: response.data.data.rows[i].name})
        }
      }).catch(error => {
        console.log('error', error)
      })

      axios.get("fitness/v1/membership_status/").then(response => {
          this.dataMembershipStatus = response.data.data.rows;
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  created () {
    this.addData.branch_id = 'single'
    this.fetchData()
  }
}
</script>

<style>
</style>
